import React from "react";
import BasePage from "../../../UI/BasePage/BasePage";
import Aux from "../../../hoc/Aux";
import { CardSection } from "../../../UI/ContentSection/ContentSection";
import { Container } from "../../../UI/ContentSection/ContentSection";

//Content
import Idea from "./Content/Idea";
import Premise from "./Content/Premise";
import Start from "./Content/Start";
import Production from "./Content/TheProductionPlace";
import Pattern from "./Content/Pattern";
import Sample from "./Content/Sample";
import ProgressContent from "./Content/Progress";
import Why from "./Content/Why";

import progressImg from "../../../assests/images/progress.png";
const Progress = () => {
  return (
    <Aux>
      <BasePage
        title={"OUR PROGRESS STEP BY STEP"}
        image={progressImg}
        textLineOne={
          "WE STARTED WITHOUT KNOWING A THING ABOUT THE TEXTILE INDUSTRY."
        }
        textLineTwo={
          "WE KNOCKED AT THE DOORS OF FACTORIES, LOOKED  FOR PRODUCTION PLACES,"
        }
        textLineThree={
          "CRASH COURSES AND THE ADVICE OF EXPERTS. HE WHO SEEKS WILL FIND..."
        }
      />
      <CardSection>
        <Container>
          <Idea />
          <Premise />
          <Start />
          <Production />
          <Pattern />
          <Sample />
          <ProgressContent />
          <Why />
        </Container>
      </CardSection>
    </Aux>
  );
};

export default Progress;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Progress.js